import { CustomerEntityView } from "../models/CustomerEntityView";

export class AgentsMacroGroupView
{
        public agentsMacroGroupId: number;
        public customer: CustomerEntityView;
        public name: string;
        public creationDate: Date;
        public lastChangeTime: Date;
        public mustHaveHeadOffices: boolean;
        public allowDuplicates: boolean;
        public expirationDate?: Date;
}
